import { ShareBaseItem } from './sharebase-item';
import { isShareBaseDocument } from './sharebase-document';

export interface ShareBaseFolder extends ShareBaseItem {
    FolderName: string;
    FolderId: number;
    DateModified: string | Date;
    LibraryName: string;
    Owner: string;
    IsShare: boolean;
    IsSharedByCurrentUser: boolean;
    IconId: number;
    IconName: string;
    TransferredFromUsername?:string;
    Links: {
      ParentFolderUri: string;
      ChildFoldersUri: string;
      DocumentsUri: string;
      Self: string;
      WriteACLCheckUri: string;
      ActivitiesUri: string;
      SharesUri: string;
      MailSharedUsersUri: string;
      ShareWithUsersOrGroupsUri: string;
      IconUri: string;
      TagTypesUri: string;
      ZipContentUri: string;
      SubscribersUri: string;
      NotificationSettingsUri: string;
    };
    Embedded: {
      Folders: ShareBaseFolder[];
      Path: any[]; // ICollection<object> in API code.
    },
    HasActiveDocumentTasks?:boolean;
}

export function isShareBaseFolder(item:any): item is ShareBaseFolder {
  return item && angular.isDefined(item.FolderId) && !isShareBaseDocument(item);
}


// WEBPACK FOOTER //
// ./src/phoenix/domain/sharebase-folder.ts